<template>
  <component :is="tag" ref="mount" :class="['raw-html', { '-pre-line': preserveBreaks, '-align-left': alignLeft }]">
    <slot />
  </component>
</template>

<script>
import DOMPurify from 'dompurify'

export default {
  name: 'RawHtml',
  props: {
    tag: { type: String, default: 'div' },
    html: { type: [String, Object], default: () => ({}) },
    preserveBreaks: { type: Boolean, default: false },
    alignLeft: { type: Boolean, default: false }
  },
  mounted() { this.renderHTML() },
  watch: {
    html: { immediate: true, deep: true, handler: 'renderHTML' }
  },
  methods: {
    renderHTML() {
      this.$nextTick(() => {
        const mount = this.$refs.mount
        if (!mount) return

        // clone slot nodes (optional)
        const { default: slots = [] } = this.$slots
        const nodes = slots.map(v => v?.elm).filter(Boolean).map(el => el.cloneNode(true))

        // clear only the inner mount, not component root
        mount.innerHTML = ''
        nodes.forEach(n => mount.appendChild(n))

        // normalize input to before/after
        const input = typeof this.html === 'string' ? { after: this.html } : (this.html || {})
        const map = { afterbegin: input.before || null, beforeend: input.after || null }

        Object.entries(map).forEach(([pos, content]) => {
          if (!content) return
          const clean = DOMPurify.sanitize(content, {
            ALLOWED_TAGS: ['b','i','em','strong','a','p','br','ul','ol','li','span','img', 'iframe', 'video'],
            FORBID_TAGS: ['pre','code'],
            USE_PROFILES: { html: true }
          })
          mount.insertAdjacentHTML(pos, clean)
        })

        // link normalization
        mount.querySelectorAll('a[href^="http"]').forEach(link => {
          link.target = '_blank'
          link.rel = 'noopener'
        })
      })
    }
  }
}
</script>
